import { render, staticRenderFns } from "./openingTime.vue?vue&type=template&id=7ca25e54&scoped=true&"
import script from "./openingTime.vue?vue&type=script&lang=js&"
export * from "./openingTime.vue?vue&type=script&lang=js&"
import style0 from "./openingTime.vue?vue&type=style&index=0&id=7ca25e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca25e54",
  null
  
)

export default component.exports